import React, { useState, useContext } from 'react';
import { TransformContext } from '../TransformContext';

import cloneDeep from 'lodash/cloneDeep';
import { ItemTypes } from '../ItemTypes';

const KeyboardButton = ({ side, button, buttonWidth }) => {
    let tContext = useContext(TransformContext);
    const symbol = cloneDeep(ItemTypes.SYMBOL[button])[0];

    const handleAddItemToFormula = () => {
        let items = cloneDeep(tContext.formulaItems);

        let maxId = 0;

        if (items.length) {
            let itemIds = items.map((item) => {
                return item.id;
            });

            maxId = Math.max.apply(Math, itemIds);
        }
        const item = cloneDeep(ItemTypes.SYMBOL[button]);
        item[0]['id'] = maxId + 1;
        items.push(...item);

        tContext.setFormulaHistory(items);
        tContext.setFormulaItems(items);
    };

    const sideClass =
        side == 'right'
            ? 'calculator-right-side-button'
            : 'calculator-left-side-button';
    return (
        <div
            className={sideClass}
            onClick={() => {
                handleAddItemToFormula();
            }}
            style={{ width: buttonWidth ?? '' }}
        >
            <span
                dangerouslySetInnerHTML={{
                    __html: symbol.display
                }}
            ></span>
        </div>
    );
};
export default KeyboardButton;
